module.exports = __webpack_public_path__ + "static/media/pttwhite.91554fbe.svg";